import { Avatar, Box, Text } from '@factorialco/deprecated-design-system'
import { F0TagRaw } from '@factorialco/f0-react'
import { Handle, NodeProps, Position } from '@xyflow/react'

import CollapsibleButton from 'modules/job_catalog/components/DevJobCatalogTree/components/CollapsibleButton'
import { CustomNode } from 'modules/job_catalog/components/DevJobCatalogTree/types'
import {
  NODE_TYPES,
  getTextFromNodeType,
  isNodeType,
  nodeTypeIcon,
} from 'modules/job_catalog/lib/nodesUtils'

const Node = (props: NodeProps<CustomNode>) => {
  const nodeType = isNodeType(props.data.type) ? props.data.type : NODE_TYPES.ROOT
  const icon = nodeTypeIcon(nodeType)
  const isSelected = false

  return (
    <Box justifyContent="center" alignItems="center">
      <Box
        position="relative"
        justifyContent="center"
        alignItems="center"
        onClick={() => {}}
        border={isSelected ? { all: { color: 'viridian800', style: 'solid', width: 's4' } } : {}}
        borderRadius={{ all: 'rel333' }}
        padding="s2"
      >
        <Avatar size="s64" label={props.data.name} />
        <Text weight="semibold" size="300" whiteSpace="nowrap" ellipsis color="grey1000">
          {props.data.name}
        </Text>
        <F0TagRaw text={getTextFromNodeType(props.data.type)} icon={icon} />
      </Box>
      <Handle type="target" position={Position.Top} style={{ backgroundColor: 'transparent' }} />
      <Handle type="source" position={Position.Bottom} style={{ backgroundColor: 'transparent' }} />
      <CollapsibleButton
        childrenCount={props.data.childrenCount}
        isExpanded={props.data.expanded}
      />
    </Box>
  )
}

export default Node
